import { useRouter } from 'next/router';
import { createContext, Dispatch, SetStateAction, useContext, useEffect, useState } from 'react';

export const QuerySearchContext = createContext<{
  search: string;
  setSearch?: Dispatch<SetStateAction<string>>;
}>({ search: '' });

export const QuerySearchContextProvider = ({
  children,
  search: initialSearch,
}: {
  children: React.ReactNode;
  search?: string;
}) => {
  const router = useRouter();
  const [search, setSearch] = useState(initialSearch || (router.query.search as string));

  useEffect(() => {
    if (router.query.search !== search) {
      setSearch(router.query.search as string);
    }
  }, [router, router.query, router.query.search]);

  return (
    <QuerySearchContext.Provider value={{ search, setSearch }}>
      {children}
    </QuerySearchContext.Provider>
  );
};

export const useQuerySearch = () => {
  const ctx = useContext(QuerySearchContext);
  return ctx;
};
